var exports = {
  "B_": "MessageJumpLink.module__jumpLinkButton___U3dRX3",
  "y_": "MessageJumpLink.module__part___U3dRX3",
  "Kk": "MessageJumpLink.module__icon___U3dRX3",
  "$f": "MessageJumpLink.module__guildIcon___U3dRX3",
  "ds": "MessageJumpLink.module__guildInitials___U3dRX3",
  "yF": "MessageJumpLink.module__divider___U3dRX3",
  "UU": "MessageJumpLink.module__name___U3dRX3",
  "m0": "MessageJumpLink.module__noAccess___U3dRX3",
};

module.exports = exports;
